import type { User } from '@platform2-lib/models';
import { create } from 'zustand';

export interface ProfileStore {
  user: User | null;
  setUser: (user: User) => void;
  hasFeature: (feature: string) => boolean;
  feat: Record<
    | 'chartLimitedAccess'
    | 'darkMode'
    | 'selectAudiences'
    | 'selectAgentVersion',
    { enabled: boolean }
  >;
}

export const useProfileStore = create<ProfileStore>()((set, get) => ({
  user: null,
  setUser: (user: User) => set({ user }),
  hasFeature: (feature: User['customer_features'][number]) =>
    !!get().user?.['customer_features']?.includes(feature),
  feat: {
    chartLimitedAccess: {
      get enabled() {
        return (
          get().hasFeature('charts_limit_free') ||
          get().hasFeature('charts_limit_plus')
        );
      }
    },
    darkMode: {
      get enabled() {
        return get().hasFeature('spark_unstyled_dark_theme');
      }
    },
    selectAudiences: {
      get enabled() {
        return get().hasFeature('spark_saved_audiences');
      }
    },
    selectAgentVersion: {
      get enabled() {
        return get().hasFeature('insights_app_engine_dropdown');
      }
    }
  }
}));
